import {registerPlugin} from '@capacitor/core'

export interface IAppReadyPlugin {
  notifyAppReady(): Promise<{ success: boolean }>
}

const AppReadyPlugin = registerPlugin<IAppReadyPlugin>('AppReady')

export {AppReadyPlugin}

